module.exports = __webpack_public_path__ + "img/udinese.511235df.png";